import { UIMFullscreenTabView } from './UIMFullscreenTabView.ts';
import { UIMRoomModeController } from './UIMRoomModeController.ts';
import { UIMRoomMapController } from './UIMRoomMapController.ts';
import { uiManager } from '../../EntryMobile.ts';
import { RoomStep } from './UIMCreateRoomController.ts';
import { createDiv } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { showBecomeMemberDialog } from '../../../../shared/scripts/ui_popup/showBecomeMemberDialog.ts';
import { AnalyticEventValue } from '../../../../../shared/entity_datas/EntityDatas.ts';
var EditPageTabs = /*#__PURE__*/ function(EditPageTabs) {
    EditPageTabs[EditPageTabs["SelectMode"] = 0] = "SelectMode";
    EditPageTabs[EditPageTabs["SelectMap"] = 1] = "SelectMap";
    return EditPageTabs;
}(EditPageTabs || {});
export class UIMRoomEditPageController {
    initializeRoomPageView() {
        const title = {
            key: 'strings:roomPage.notifications.edit'
        };
        const tabProperties = [
            {
                title: {
                    key: 'strings:game.settings.gameInfoTab.gameMode.titleAbbreviated'
                },
                isActive: true,
                containerClass: 'm-room-settings-cards-container-grid room_center_options',
                id: 0
            },
            {
                title: {
                    key: 'strings:game.settings.gameInfoTab.map.title'
                },
                isActive: false,
                containerClass: 'm-room-settings-cards-container-grid room_center_options',
                id: 1
            }
        ];
        const buttonText = {
            key: 'strings:roomPage.save'
        };
        this.roomPageView = new UIMFullscreenTabView(title, tabProperties, buttonText);
    }
    async initializeControllers() {
        this.roomModeController = new UIMRoomModeController(this.roomPageView.getContainerWithTabIdx(0), this.roomState);
        this.roomMapController = new UIMRoomMapController(this.roomPageView.getContainerWithTabIdx(1), this.roomState);
        this.roomPageView.setOnClickContinueButton((isLastStep)=>this.goToPageView(isLastStep));
    }
    createAdElement() {
        const adContainer = createDiv('banner_private_ad');
        this.roomPageView.body.prepend(adContainer);
        uiManager.adController.showLobbyVerticalAds();
    }
    update(roomState) {
        this.roomState = roomState;
        this.roomModeController.update(roomState);
        this.roomMapController.update(roomState);
    }
    showView(tabIndex) {
        this.roomPageView.show();
        if (tabIndex != undefined) this.roomPageView.updateActiveTabToIndex(tabIndex);
    }
    hideView() {
        this.roomPageView.hide();
    }
    exitView() {
        this.roomPageView.updateActiveTabToIndex(0);
        this.roomPageView.hide();
    }
    goToPageView(isLastStep) {
        if (!isLastStep) return;
        const isMapAccessible = this.roomMapController.isSelectedMapAccessible;
        const isModeAccessible = this.roomModeController.isSelectedModeAccessible;
        if (isMapAccessible && isModeAccessible) {
            return this.showRoomPage();
        }
        showBecomeMemberDialog('gameplay', AnalyticEventValue.PopupMembershipIncentiveMobileRoomEdit);
    }
    // eslint-disable-next-line class-methods-use-this
    showRoomPage() {
        uiManager.createRoomController.setShowPageOnNextUpdate(RoomStep.RoomPage, true);
    }
    constructor(roomState){
        this.roomState = roomState;
        this.initializeRoomPageView();
        this.createAdElement();
        void this.initializeControllers();
    }
}
